import axios              from "axios";
import { api }            from "../_constants";
import handleResponse     from "./handleResponse";
import getVoucherUser     from "./handleVoucherUser";
import getVoucherData     from "./handleVoucherData";
import getAppStats        from "./handleAppStats";
import getAppId           from "./handleAppId";
import getWebServiceCount from "./handleWebServiceCount";

export const wu_RegisterLightService = {
  wu_omtregistrationTriggerOTP,
  wu_omtRegistrationResendOTP,
  wu_omtRegistrationValidateOTP,
};
//----------------------------------------------------------------------------------------------------
function wu_omtregistrationTriggerOTP(reqData) {
  const methName = "wu_omtregistrationTriggerOTP ";

  let localUrl = "";
  let rv       = reqData.recaptchaVerify;
//if(rv && rv!=="" && rv!==null){ localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationTriggerOTP?country=GR"+"&recaptchaVerify="+rv.replace(/"/g,""); }
//else                          { localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationTriggerOTP?country=GR"; }
  localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationTriggerOTP?country=GR";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
      "appStats"                    : getAppStats(api.webappENV,reqData["val1"]),
      "webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
      "recaptchaVerify"             : rv.replace(/"/g,""),
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = ""+
  // "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>"+
  // "<reqAddCustomer>"+
  //     "<email>"+reqData.email+"</email>"+
  //     "<telephone>"+reqData.telephone+"</telephone>"+
  //     "<preferredLanguage>"+reqData.preferredLanguage+"</preferredLanguage>"+
  //     "<password>"+reqData.password+"</password>"+
  //     "<isMobile>"+reqData.isMobile+"</isMobile>"+
  //     "<wantMktInfo>"+reqData.wantMktInfo+"</wantMktInfo>"+ //consent-offers
  // "</reqAddCustomer>";
  const data = {
    "email"             : reqData.email,
    "telephone"         : reqData.telephone,
    "preferredLanguage" : reqData.preferredLanguage,
    "password"          : reqData.password,
    "isMobile"          : parseInt(reqData.isMobile),
    "wantMktInfo"       : reqData.wantMktInfo
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_omtRegistrationResendOTP(reqData) {
  const methName = "wu_omtRegistrationResendOTP ";

  let localUrl = "";
  let rv       = reqData.recaptchaVerify;
//if(rv && rv!=="" && rv!==null){ localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationResendOTP?"recaptchaVerify="+rv.replace(/"/g,""); }
//else                          { localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationResendOTP?"; }
  localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationResendOTP";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
      "appStats"                    : getAppStats(api.webappENV,reqData["val1"]),
      "webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
      "recaptchaVerify"             : rv.replace(/"/g,""),
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = ""+
  // "<reqAddCustomer>"+
  //     "<email>"+reqData.email+"</email>"+
  //     "<telephone>"+reqData.telephone+"</telephone>"+
  //     "<isMobile>"+reqData.isMobile+"</isMobile>"+
  // "</reqAddCustomer>";
  const data = {
    "email"     : reqData.email,
    "telephone" : reqData.telephone,
    "isMobile"  : parseInt(reqData.isMobile)
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_omtRegistrationValidateOTP(reqData) {
  const methName = "wu_omtRegistrationValidateOTP ";

  let localUrl = "";
  let rv       = reqData.recaptchaVerify;
//if(rv && rv!=="" && rv!==null){ localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationValidateOTP?"recaptchaVerify="+rv.replace(/"/g,""); }
//else                          { localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationValidateOTP?"; }
  localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtRegistrationValidateOTP";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
      "recaptchaVerify"             : rv.replace(/"/g,""),
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = ""+
  // "<reqAddCustomer>"+
  //     "<email>"+reqData.email+"</email>"+
  //     "<verificationCode>"+reqData.verificationCode+"</verificationCode>"+
  // "</reqAddCustomer>";
  const data = {
    "email"            : reqData.email,
    "verificationCode" : reqData.verificationCode
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
